import * as React from "react"
import { InputGroup, InputGroupAddon, InputGroupTextarea } from "@design/ui/input-group"

export interface ChatComposerWiring {
  inputGroup: Omit<React.ComponentProps<typeof InputGroup>, "className" | "children">
  inputGroupContent?: React.ReactNode
  inputGroupInput: Omit<React.ComponentProps<typeof InputGroupTextarea>, "placeholder">
  inputGroupAddon: Omit<React.ComponentProps<typeof InputGroupAddon>, "align" | "children">
  inputGroupAddonSlot?: React.ReactNode
}

export const ChatComposerContext = React.createContext<ChatComposerWiring | null>(null)

export function useWiring(): ChatComposerWiring {
  const wiring = React.useContext(ChatComposerContext)
  if (wiring === null) {
    throw new Error("ChatComposerScreen: render inside <ChatComposerContext.Provider>")
  }
  return wiring
}
